import { styled } from '@mui/material/styles'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { Box, InputAdornment, Typography } from '@mui/material'
import i18n from 'i18n'
import React from 'react'

type MyInputProps = TextFieldProps & {
  max?: number
  type?: string
  maxLength?: number
  endAdornment?: React.ReactNode
}

const StyledTextField = styled(TextField)(() => {
  const isRtl = i18n.dir() === 'rtl'

  return {
    '& .MuiOutlinedInput-root': {
      overflow: 'hidden'
    },
    '& .MuiInputAdornment-positionEnd': {
      marginRight: isRtl ? 0 : 8,
      marginLeft: isRtl ? 8 : 0,
      maxHeight: 'none'
    },
    '& .MuiInputBase-input': {
      textAlign: isRtl ? 'right' : 'left'
    }
  }
})

const SizeTextFieldInput = (props: MyInputProps) => {
  const {
    max,
    maxLength,
    endAdornment,
    label,
    inputProps,
    InputProps,
    ...rest
  } = props

  const isRtl = i18n.dir() === 'rtl'

  return (
    <Box sx={{ position: 'relative' }}>
      {label ? (
        <Typography
          position={'absolute'}
          fontSize={'0.75rem'}
          color={'#848484'}
          sx={{
            top: -8,
            left: isRtl ? 'auto' : 14,
            right: isRtl ? 14 : 'auto',
            backgroundColor: 'white',
            paddingLeft: '4px',
            paddingRight: '4px',
            zIndex: 1,
            pointerEvents: 'none'
          }}
        >
          {label}
        </Typography>
      ) : null}
      <StyledTextField
        {...rest}
        label={undefined}
        inputProps={{
          max,
          maxLength,
          ...inputProps
        }}
        InputProps={{
          ...InputProps,
          endAdornment: endAdornment ? (
            <InputAdornment position="end">{endAdornment}</InputAdornment>
          ) : (
            InputProps?.endAdornment
          )
        }}
        style={{ fontSize: '14px' }}
        type={props.type ?? 'number'}
      />
    </Box>
  )
}

export default SizeTextFieldInput
